export default __webpack_public_path__ + "static/media/personality_ISTp.a2fb37f3.png";